import { Grid, TextField } from "@mui/material";
import { useState } from "react";
import Counter from "../shared/counter.component";
import { SettingsBulkMessageIcon, SettingsGroupContactsIcon, SettingsPinnedContactsIcon } from "../../icon";

interface Props {
	PhoneSettings: any[],
	HandleContactCount: (e: any) => void,
	HandlePinCount: (value: any, id?: string) => void,
	IsMobileDevice: boolean;
}

const EditSettings = (props: Props) => {
	const [symbolsArr, setSymbolsArr] = useState(["e", "E", "+", "-", "."])

	return (

		<>
			{props.PhoneSettings.length > 0 &&
				<>
					{props.PhoneSettings.map((row, index) => {
						if (index === 0) {
							return (
								<Grid container className={"bb-primary-divider-4"}>
									<Grid item xs={9} className={`${props.IsMobileDevice ? '' : ''} pl-2 t-align-left d-flex align-center`}>
										{row.code === "MPC" ? <SettingsPinnedContactsIcon className={`${props.IsMobileDevice ? "" : ""} w-4 mr-2`} /> : ''}
										<p className={`${props.IsMobileDevice ? "h2" : "h4-regular"} color-settings-items-heading t-align-left`}>
											{row.name}
										</p>
									</Grid>
									<Grid item className={`b-none d-flex justify-center my-auto  ${props.IsMobileDevice ? "h2" : "h3-semibold"}`} xs={3}>
										<Counter id={row.id} onChange={props.HandlePinCount} count={parseInt(row.value)} IsMobileDevice={props.IsMobileDevice} />

									</Grid>
								</Grid>
							)
						}
						else {
							return (

								<Grid container className={"bb-primary-divider-4"}>
									<Grid item xs={props.IsMobileDevice ? 10 : 10} className={`${props.IsMobileDevice ? '' : ''} pl-2 t-align-left d-flex align-center`}>
										{row.code === "MGC" ? <SettingsGroupContactsIcon className={`${props.IsMobileDevice ? "" : ""} w-4 mr-2`} /> : row.code === "MMC" ? <SettingsBulkMessageIcon className={`${props.IsMobileDevice ? "" : ""} w-4 mr-2`} /> : ''}
										<p className={`${props.IsMobileDevice ? "h2" : "h4-regular"} color-settings-items-heading t-align-left`}>
											{row.name}
										</p>
									</Grid>
									{row.code === "MGC" ?
										<Grid item className={`b-none d-flex justify-center my-auto ${props.IsMobileDevice ? "h2" : "h3-semibold"}`} xs={props.IsMobileDevice ? 2 : 2}>
											<TextField
												required type="number"
												id={props.PhoneSettings[1].id} variant="outlined" margin='dense'
												InputProps={{
													classes: {
														input: props.IsMobileDevice ? 'font-phone-mobile-field' : 'h4-regular t-align-center color-text-field-focused bg-color-settings-text-field-background', notchedOutline: 'settings-text-field-border'
													},
												}}
												className={`mr-2 my-auto`}
												onChange={props.HandleContactCount}
												onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}
												defaultValue={parseInt(row.value)}
											/>
										</Grid> :
										<Grid item className={`b-none d-flex justify-center my-auto ${props.IsMobileDevice ? "h2" : "h3-semibold"}`} xs={props.IsMobileDevice ? 2 : 2}>
											<TextField required type="number" id={props.PhoneSettings[2].id} variant="outlined" margin='dense'
												InputProps={{
													classes: {
														input: props.IsMobileDevice ? 'font-phone-mobile-field' : 'h4-regular t-align-center color-text-field-focused bg-color-settings-text-field-background', notchedOutline: 'settings-text-field-border'
													},
												}}
												className={`mr-2 my-auto`}
												onChange={props.HandleContactCount}
												onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}
												defaultValue={parseInt(row.value)}
											/>
										</Grid>}

								</Grid>
							)
						}
					})}
				</>
			}
		</>
	)
}
export default EditSettings;